import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import Alert from "@material-ui/lab/Alert";
import { CircularProgress } from "@material-ui/core";

import { setDialogHandle } from "../../actions/dialog";
import { IDialogChildComponent } from "../../reducers/dialog";
import Styles from "../../scss/deleteDialog.module.scss";
import DisabledActionWrapper from "../../yoello-lib/modules/components/DisabledActionWrapper";

interface Props extends IDialogChildComponent {
  pre?: JSX.Element;
  onCancel: () => void;
  onSubmit: () => void;
  dialogTitle: string | JSX.Element;
  contents: JSX.Element;
  isDisabled?: boolean;
  disabledMessage?: string;
  buttonText: string;
  isArrayModal?: boolean;
  onDisabledClick?: Function;
}

const DeleteDialog = (props: Props) => {
  const dispatch = useDispatch()
  const onOpen = () => {
    // isArrayModal is for the new of modals which is using an array ot kinda stack to handle the modals
    dispatch(
      setDialogHandle({
        Component: DeleteDialogContent,
        ComponentProps: props,
        dialogTitle: props.dialogTitle,
        isOpen: true,
        isFormDialog:false,
        styles: { className: Styles.deleteDialog },
      })
    );
  };

  return (
    <>
      {props.pre}
      <DisabledActionWrapper 
        disabled={props.isDisabled}
        onDisabledClick={() => props.onDisabledClick?.()}
      >
        <Button
          variant={"contained"}
          startIcon={<DeleteIcon />}
          onClick={onOpen}
          style={props.isDisabled ? {} : { color: "#F52D5C", backgroundColor: "#FEEAEE" }}
          data-component-name="DELETE"
          disabled={props.isDisabled}
        >
          {props.buttonText}
        </Button>
      </DisabledActionWrapper>
      
    </>
  );
};

export default DeleteDialog;

export const DeleteDialogContent = (props: Props) => {
  const { onClose, onSubmit, contents, isDisabled, disabledMessage } = props;
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="delete-dialog-content">
      <div className={Styles.Content}>
        {isLoading ? <div className={Styles.loader}><CircularProgress /></div> : contents }
      </div>

      {isDisabled && (
        <div className={Styles.DisabledMessage}>
          <Alert severity="error">{disabledMessage}</Alert>
        </div>
      )}

      <div className={Styles.ButtonsWrapper}>
      {!isLoading && 
        <Button
          variant={"contained"}
          onClick={onClose}
          style={{ color: "#212121", backgroundColor: "#ffffff" }}
          data-component-name="CANCEL"
        >
          {t("delete.cancel")}
        </Button>
      }

      {!isLoading && 
        <Button
          variant={"contained"}
          startIcon={<DeleteIcon />}
          onClick={async () => {
            setIsLoading(true);

            await onSubmit();

            setIsLoading(false);
          }}
          disabled={isDisabled}
          style={{ color: "#F52D5C", backgroundColor: "#FEEAEE" }}
          data-component-name="CONFIRM"
        >
          {t("delete.confirm")}
        </Button>
      }
      </div>
    </div>
  );
};
